var scope_0 = require('C:/Users/youss/Documents/GitHub/cym-identity-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/939016a5abcfa66f639727f035f4e077.js').default;
var scope_1 = require('C:/Users/youss/Documents/GitHub/cym-identity-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d469b760695bbc818fbe5e4c66b85c2e.js').default;
var scope_2 = require('C:/Users/youss/Documents/GitHub/cym-identity-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d599da1803c404eb2a1bfbab58120296.js').default;
var scope_3 = require('C:/Users/youss/Documents/GitHub/cym-identity-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    